<template>
	<div class="news-det-page">
		<div class="section-container">
			<!-- 面包屑 -->
			<div class="news-det-crumb">
				<BreadCrumb></BreadCrumb>
			</div>

			<!-- 文章主体 -->
			<div class="news-det-card" v-if="article">
				<h1 class="news-det-title">{{ article.newsTitle }}</h1>
				<div class="news-det-meta">
					<span class="meta-item"><i class="el-icon-time"></i> 发布时间：{{ article.updateTime? article.updateTime.substring(0, 10) : article.createTime.substring(0, 10) }}</span>
					<!-- <span class="meta-item" v-if="article.source"><i class="el-icon-document"></i> 来源：{{ article.source }}</span> -->
					<!-- <span class="meta-item" v-if="article.view"><i class="el-icon-view"></i> {{ article.view }} 次阅读</span> -->
				</div>
				<!-- <div class="news-det-summary" v-if="article.summary">{{ article.summary }}</div> -->
				<div class="news-det-content" v-html="article.newsInfo"></div>
			</div>

			<el-empty v-else description="文章不存在或已下架"></el-empty>

			<!-- 上/下一篇 -->
			<!-- <div class="news-det-nav" v-if="article">
				<div class="nav-item" :class="{ disabled: !prevArticle }" @click="handleJump(prevArticle)">
					<span class="nav-label">上一篇</span>
					<span class="nav-title">{{ prevArticle ? prevArticle.title : '没有更早的文章了' }}</span>
				</div>
				<div class="nav-item" :class="{ disabled: !nextArticle }" @click="handleJump(nextArticle)">
					<span class="nav-label">下一篇</span>
					<span class="nav-title">{{ nextArticle ? nextArticle.title : '已经是最新文章了' }}</span>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
// import { newsList } from './newsData.js';
import BreadCrumb from '@/components/Breadcrumb/index.vue';
import { mapActions } from 'vuex';
import { getNewsDetail } from '@/api/news/news';

export default {
	name: 'NewsDet',
	components: {
		BreadCrumb
	},
	data() {
		return {
			article: null
		};
	},
	computed: {
		curId() {
			return Number(this.$route.query.id) || 0;
		},
		// article() {
		// 	return this.newsList.find(item => item.id === this.curId);
		// },
		// curIndex() {
		// 	return this.newsList.findIndex(item => item.id === this.curId);
		// },
		// prevArticle() {
		// 	if (this.curIndex <= 0) return null;
		// 	return this.newsList[this.curIndex - 1];
		// },
		// nextArticle() {
		// 	if (this.curIndex < 0 || this.curIndex >= this.newsList.length - 1) return null;
		// 	return this.newsList[this.curIndex + 1];
		// }
	},
	methods: {
		...mapActions('Settings', ['setBreadcrumbList']),
		handleJump(target) {
			if (!target) return;
			this.$router.push({ path: '/NewsDet', query: { id: target.id } });
		},

		getNewsDetail() {
			getNewsDetail(this.curId).then(res => {
				if (res.code === 200) {
					this.article = res.data;
					// 富文本内 www.teguitong.com 链接的 host 跟随当前站点（本地开发与生产环境均替换）
					this.rewriteNewsLinks();
				} else {
					console.log(res.msg);
				}
			});
		},

		// 将富文本中 www.teguitong.com 的链接 host 替换为当前站点域名（本地开发与生产环境均替换）
		rewriteNewsLinks() {
			if (!this.article || !this.article.newsInfo) return;
			this.article.newsInfo = this.article.newsInfo.replace(/(https?:)?\/\/www\.teguitong\.com/g, window.location.origin);
		},
	},
	created() {
		const breadcrumbs = [
			{ path: '/Home', name: '首页' },
			{ path: '/NewsList', name: '新闻资讯' },
			{ name: '新闻详情' }
		];
		this.setBreadcrumbList(breadcrumbs);
		this.getNewsDetail();
	}
};
</script>

<style lang="less" scoped>
.news-det-page {
	background: #f8fafc;
	min-height: calc(100vh - 120px);
	// padding: 32px 0 60px;
	padding-bottom: 60px;
}

.section-container {
	width: 70%;
	margin: 0 auto;
}

.news-det-crumb {
	// margin-bottom: 16px;
}

.news-det-card {
	background: #ffffff;
	border-radius: 16px;
	padding: 40px 48px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.04);
	border: 1px solid #f1f5f9;
}

.news-det-title {
	font-size: 26px;
	font-weight: 800;
	color: #0f172a;
	line-height: 1.4;
	margin: 0 0 20px;
}

.news-det-meta {
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	padding-bottom: 20px;
	margin-bottom: 24px;
	border-bottom: 1px dashed #e2e8f0;

	.meta-item {
		font-size: 13px;
		color: #94a3b8;

		i {
			color: #94a3b8;
			margin-right: 4px;
		}
	}
}

.news-det-summary {
	background: #f8fafc;
	border-left: 4px solid #2563eb;
	padding: 14px 18px;
	border-radius: 6px;
	font-size: 14px;
	color: #475569;
	line-height: 1.75;
	margin-bottom: 28px;
}

.news-det-content {
	/deep/ p {
		margin: 0;
	}

	/deep/ h1,
	/deep/ h2,
	/deep/ h3,
	/deep/ h4,
	/deep/ h5,
	/deep/ h6 {
		margin: 0;
	}


	// font-size: 15px;
	// color: #1e293b;
	// line-height: 1.9;

	// /deep/ p {
	// 	margin: 0 0 16px;
	// }

	// /deep/ h2,
	// /deep/ h3 {
	// 	font-weight: 700;
	// 	color: #0f172a;
	// 	margin: 24px 0 12px;
	// }

	// /deep/ h2 {
	// 	font-size: 20px;
	// }

	// /deep/ h3 {
	// 	font-size: 17px;
	// }

	// /deep/ ul,
	// /deep/ ol {
	// 	padding-left: 24px;
	// 	margin: 0 0 16px;

	// 	li {
	// 		margin-bottom: 6px;
	// 	}
	// }

	/deep/ img {
		max-width: 100%;
		// border-radius: 8px;
	}
}

.news-det-nav {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	margin-top: 32px;

	.nav-item {
		background: #ffffff;
		border: 1px solid #f1f5f9;
		border-radius: 12px;
		padding: 16px 20px;
		cursor: pointer;
		transition: all 0.2s;

		&:hover:not(.disabled) {
			border-color: #2563eb;
			box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);

			.nav-title {
				color: #2563eb;
			}
		}

		&.disabled {
			cursor: not-allowed;
			opacity: 0.6;
		}

		.nav-label {
			display: block;
			font-size: 12px;
			color: #94a3b8;
			margin-bottom: 6px;
		}

		.nav-title {
			display: block;
			font-size: 14px;
			color: #1e293b;
			font-weight: 500;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			transition: color 0.2s;
		}
	}
}

@media screen and (max-width: 767px) {
	.section-container {
		width: 96%;
	}

	.news-det-card {
		padding: 24px 20px;
	}

	.news-det-title {
		font-size: 20px;
	}

	.news-det-nav {
		grid-template-columns: 1fr;
	}
}
</style>
